import { BiDrink, } from 'react-icons/bi';
import { BsBuilding, BsMic, BsCashCoin, BsMusicNoteBeamed, BsSnow, BsSun } from 'react-icons/bs';
import { AiOutlineCar } from 'react-icons/ai';
import { MdChildCare, MdOutlineElevator } from 'react-icons/md';
import { FiMonitor } from 'react-icons/fi';
import { IoBalloonOutline } from 'react-icons/io5';
import { RiExchangeBoxLine } from 'react-icons/ri';

export const hotel_facts = {
    "en": {
        "contextTree": {
            "45": {
                "label": "Stay Safe",
                "facts": [],
                "sub": {
                    "46": {
                        "label": "General",
                        "facts": [
                            514,
                            488,
                            487,
                            486,
                            489,
                            485,
                            526,
                            530,
                            529,
                            518,
                            517,
                            516,
                            515,
                            509,
                            507,
                            508
                        ]
                    },
                    "47": {
                        "label": "Services",
                        "facts": [
                            490,
                            524,
                            491,
                            528,
                            525,
                            522,
                            492,
                            494,
                            493
                        ]
                    },
                    "48": {
                        "label": "Board",
                        "facts": [
                            520,
                            519,
                            521,
                            497,
                            495,
                            496
                        ]
                    },
                    "49": {
                        "label": "Rooms",
                        "facts": [
                            513,
                            527,
                            523,
                            499,
                            498,
                            500
                        ]
                    },
                    "50": {
                        "label": "Standards",
                        "facts": [
                            510,
                            512,
                            506,
                            503,
                            502,
                            504,
                            505,
                            501,
                            534
                        ]
                    }
                },
                order: 1
            },
            "16": {
                "label": "Property info",
                "facts": [],
                "sub": {
                    "20": {
                        "label": "General property info",
                        "facts": [
                            511,
                            347,
                            332,
                            330,
                            331,
                            329,
                            328,
                            327
                        ],
                        "invisible": true
                    },
                    "15": {
                        "label": "Category",
                        "facts": [
                            533,
                            326,
                            325
                        ],
                        "invisible": true
                    },
                    "12": {
                        "label": "Accommodation types",
                        "facts": [
                            429,
                            426,
                            427,
                            432,
                            431,
                            430,
                            428,
                            425,
                            424,
                            423,
                            416,
                            409,
                            421,
                            414,
                            407,
                            408,
                            415,
                            422,
                            417,
                            419,
                            412,
                            420,
                            418,
                            413,
                            410,
                            411,
                            406,
                            405,
                            404,
                            278,
                            277,
                            281,
                            286,
                            287,
                            283,
                            274,
                            271,
                            266,
                            270,
                            261,
                            254,
                            260,
                            258,
                            253,
                            256
                        ]
                    },
                    "21": {
                        "label": "Characteristics",
                        "facts": [
                            339,
                            338,
                            282,
                            284,
                            285,
                            280,
                            276,
                            268,
                            275,
                            262,
                            252,
                            257
                        ]
                    },
                    "42": {
                        "label": "Traveller categories",
                        "facts": [
                            397,
                            381,
                            385,
                            403,
                            438,
                            433,
                            395,
                            396,
                            398,
                            392,
                            399,
                            391,
                            394,
                            400,
                            393,
                            401,
                            389,
                            390,
                            380,
                            382,
                            386,
                            388,
                            383,
                            387,
                            384
                        ]
                    },
                    "14": {
                        "label": "Building information",
                        "facts": [
                            320,
                            321
                        ]
                    },
                    "22": {
                        "label": "Number of rooms & other",
                        "facts": [
                            316,
                            318,
                            317,
                            310,
                            309,
                            308,
                            314,
                            315,
                            313,
                            319,
                            311,
                            312
                        ]
                    }
                },
                order: 2,
                invisible: true
            },
            "5": {
                "label": "Location",
                "facts": [],
                "sub": {
                    "17": {
                        "label": "Beach",
                        "facts": [
                            89,
                            458,
                            439,
                            336,
                            334,
                            335
                        ]
                    },
                    "23": {
                        "label": "General location",
                        "facts": [
                            90,
                            91,
                            350,
                            352,
                            351,
                            348,
                            353,
                            349,
                            323
                        ]
                    },
                    "13": {
                        "label": "Distances: transport & city",
                        "facts": [
                            340,
                            307,
                            306,
                            291,
                            305,
                            298,
                            290
                        ]
                    },
                    "24": {
                        "label": "Distances: entertainment & shopping",
                        "facts": [
                            294,
                            296,
                            299,
                            302,
                            288,
                            444
                        ]
                    },
                    "25": {
                        "label": "Distances: nature",
                        "facts": [
                            295,
                            293,
                            297,
                            301,
                            300
                        ]
                    },
                    "26": {
                        "label": "Distances: ski",
                        "facts": [
                            304,
                            303,
                            292,
                            480
                        ]
                    }
                },
                order: 3
            },
            "3": {
                "label": "Facilities",
                "facts": [],
                "sub": {
                    "27": {
                        "label": "General facilities",
                        "facts": [
                            532,
                            531,
                            88,
                            87,
                            85,
                            84,
                            81,
                            72,
                            71,
                            69,
                            67,
                            62,
                            63,
                            55,
                            47,
                            45,
                            44,
                            39,
                            38,
                            34,
                            33,
                            27,
                            25,
                            22,
                            23,
                            21,
                            16,
                            17,
                            15,
                            11,
                            10,
                            8,
                            346,
                            322,
                            455,
                            440,
                            449,
                            441,
                            220
                        ]
                    },
                    "28": {
                        "label": "Food & drinks",
                        "facts": [
                            73,
                            66,
                            64,
                            65,
                            61,
                            20,
                            18,
                            14,
                            450,
                            451,
                            443
                        ]
                    },
                    "29": {
                        "label": "Entertainment & lifestyle",
                        "facts": [
                            83,
                            79,
                            77,
                            75,
                            70,
                            57,
                            56,
                            49,
                            48,
                            46,
                            42,
                            41,
                            36,
                            32,
                            31,
                            24,
                            12,
                            13,
                            9,
                            456,
                            453
                        ]
                    },
                    "43": {
                        "label": "Shopping",
                        "facts": [
                            454
                        ]
                    },
                    "30": {
                        "label": "Conferences & events",
                        "facts": [
                            82,
                            68,
                            60,
                            54,
                            51,
                            37,
                            35,
                            28,
                            29,
                            19
                        ]
                    },
                    "31": {
                        "label": "Outdoor facilities & pools",
                        "facts": [
                            86,
                            80,
                            78,
                            76,
                            59,
                            58,
                            52,
                            50,
                            43,
                            40,
                            30,
                            26,
                            457,
                            459
                        ]
                    }
                },
                order: 4
            },
            "9": {
                "label": "Rooms",
                "facts": [],
                "sub": {
                    "32": {
                        "label": "Room types & layout",
                        "facts": [
                            341,
                            182,
                            173,
                            167,
                            170,
                            153,
                            158,
                            152,
                            141,
                            123,
                            125,
                            448,
                            447,
                            442,
                            445,
                            446
                        ]
                    },
                    "33": {
                        "label": "Facilities",
                        "facts": [
                            121,
                            122,
                            120,
                            118,
                            185,
                            186,
                            179,
                            176,
                            168,
                            177,
                            169,
                            175,
                            174,
                            178,
                            181,
                            162,
                            159,
                            156,
                            345,
                            155,
                            163,
                            157,
                            146,
                            139,
                            138,
                            142,
                            147,
                            148,
                            144,
                            130,
                            129,
                            461,
                            452,
                            460
                        ]
                    },
                    "34": {
                        "label": "Beds",
                        "facts": [
                            119,
                            171,
                            161,
                            137,
                            149,
                            131,
                            132,
                            127
                        ]
                    },
                    "35": {
                        "label": "Bathroom",
                        "facts": [
                            184,
                            183,
                            166,
                            165,
                            160,
                            145,
                            140,
                            128,
                            126,
                            124,
                            135,
                            133,
                            402
                        ]
                    },
                    "36": {
                        "label": "Kitchen/Kitchenette",
                        "facts": [
                            180,
                            172,
                            154,
                            150,
                            151,
                            143,
                            136,
                            134,
                            343,
                            344,
                            462
                        ]
                    },
                    "44": {
                        "label": "Location/View",
                        "facts": [
                            164,
                            364,
                            375,
                            363,
                            365,
                            366,
                            368,
                            370,
                            374,
                            367,
                            371,
                            362,
                            369,
                            372,
                            373,
                            356,
                            361,
                            358,
                            354,
                            359,
                            355,
                            357,
                            360
                        ]
                    }
                },
                order: 5
            },
            "11": {
                "label": "Sports",
                "facts": [],
                "sub": {
                    "37": {
                        "label": "Sports: general",
                        "facts": [
                            234,
                            242,
                            245,
                            231,
                            244,
                            230,
                            233,
                            219,
                            217,
                            218,
                            223,
                            216,
                            222,
                            227,
                            221,
                            229,
                            220,
                            212,
                            211,
                            213,
                            202,
                            206,
                            208,
                            205,
                            210,
                            250,
                            246,
                            477,
                            478,
                            463,
                            464
                        ]
                    },
                    "38": {
                        "label": "Beach and watersports",
                        "facts": [
                            235,
                            236,
                            240,
                            243,
                            232,
                            226,
                            214,
                            225,
                            224,
                            215,
                            228,
                            204,
                            203,
                            209,
                            207,
                            249,
                            247,
                            465,
                            248
                        ]
                    },
                    "39": {
                        "label": "Winter sports",
                        "facts": [
                            237,
                            238,
                            241,
                            239
                        ]
                    }
                },
                order: 9,
                invisible: true
            },
            "10": {
                "label": "Wellness",
                "facts": [
                    74,
                    198,
                    201,
                    200,
                    199,
                    197,
                    193,
                    192,
                    196,
                    190,
                    191,
                    195,
                    189,
                    188,
                    187,
                    194,
                    474,
                    472,
                    479,
                    476,
                    473,
                    475,
                    467,
                    466,
                    469,
                    470,
                    468,
                    471
                ],
                order: 10,
                invisible: true
            },
            "2": {
                "label": "Entertainment",
                "facts": [
                    7,
                    5,
                    6,
                    4,
                    3,
                    1,
                    2
                ],
                order: 11,
                invisible: true
            },
            "6": {
                "label": "F&B Options",
                "facts": [],
                "sub": {
                    "40": {
                        "label": "Meal Type",
                        "facts": [
                            111,
                            105,
                            103,
                            100,
                            101,
                            97,
                            96,
                            94,
                            95,
                            92,
                            324
                        ]
                    },
                    "41": {
                        "label": "Additional offers",
                        "facts": [
                            115,
                            114,
                            112,
                            113,
                            110,
                            108,
                            109,
                            106,
                            107,
                            104,
                            102,
                            98,
                            99,
                            93,
                            376,
                            377,
                            434,
                            436,
                            437,
                            435,
                            378,
                            379
                        ]
                    }
                },
                order: 6
            },
            "7": {
                "label": "Miscellaneous",
                "facts": [
                    116,
                    53,
                    333
                ],
                order: 8
            },
            "8": {
                "label": "Payment options",
                "facts": [
                    117
                ],
                order: 7
            }
        },
        "facts": {
            "7": {
                "label": "Kids' club",
                "icon": IoBalloonOutline,
                "attributes": [
                    200,
                    20,
                    21,
                    28,
                    39,
                    1,
                    11,
                    17,
                    66,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "5": {
                "label": "Live music",
                "icon": BsMusicNoteBeamed,
                "attributes": [
                    92,
                    20,
                    21,
                    39,
                    1,
                    29,
                    192,
                    194,
                    195
                ]
            },
            "6": {
                "label": "Kids' disco",
                "attributes": [
                    200,
                    20,
                    21,
                    28,
                    39,
                    1,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195
                ]
            },
            "4": {
                "label": "Entertainment programme for children",
                "icon": FiMonitor,
                "attributes": [
                    20,
                    21,
                    39,
                    11,
                    17,
                    66,
                    191,
                    192,
                    194,
                    195,
                    197
                ]
            },
            "3": {
                "label": "Entertainment programme for adults",
                "attributes": [
                    20,
                    21,
                    39,
                    11,
                    17,
                    66,
                    191,
                    192,
                    194,
                    195,
                    197
                ]
            },
            "1": {
                "label": "Childcare service",
                "icon": MdChildCare,
                "attributes": [
                    200,
                    20,
                    21,
                    28,
                    39,
                    1,
                    11,
                    17,
                    66,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "2": {
                "label": "Entertainment programme",
                "icon": FiMonitor,
                "attributes": [
                    92,
                    20,
                    21,
                    39,
                    1,
                    11,
                    17,
                    66,
                    191,
                    192,
                    194,
                    195
                ]
            },
            "116": {
                "label": "Hire car",
                "attributes": [
                    28,
                    39,
                    1
                ]
            },
            "53": {
                "label": "Pets",
                "attributes": [
                    81,
                    20,
                    21,
                    28,
                    3
                ]
            },
            "333": {
                "label": "Minimum age",
                "attributes": [
                    68,
                    1
                ]
            },
            "117": {
                "label": "Payment options",
                "attributes": [
                    9,
                    41,
                    24,
                    4,
                    12,
                    5,
                    42,
                    32,
                    40,
                    31
                ]
            },
            "74": {
                "label": "Solarium",
                "attributes": [
                    92,
                    200,
                    69,
                    20,
                    21,
                    39,
                    1,
                    49,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "198": {
                "label": "Steam bath",
                "attributes": [
                    97,
                    94,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1,
                    49,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "201": {
                "label": "Hot tub",
                "attributes": [
                    97,
                    69,
                    20,
                    21,
                    39,
                    1,
                    49,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "200": {
                "label": "Cure treatments",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    78,
                    1
                ]
            },
            "199": {
                "label": "Thalassotherapy",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "197": {
                "label": "Spa",
                "attributes": [
                    94,
                    92,
                    200,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "193": {
                "label": "Health cure",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    78,
                    1
                ]
            },
            "192": {
                "label": "Hammam",
                "attributes": [
                    94,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1,
                    49,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "196": {
                "label": "Sauna",
                "attributes": [
                    97,
                    94,
                    92,
                    200,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1,
                    49,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "190": {
                "label": "Beauty centre",
                "attributes": [
                    92,
                    69,
                    20,
                    21,
                    1,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "191": {
                "label": "Beauty salon",
                "attributes": [
                    92,
                    200,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1,
                    49,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "195": {
                "label": "Massage treatments",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    78,
                    1
                ]
            },
            "189": {
                "label": "Ayurveda",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "188": {
                "label": "Anti-ageing treatments",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    1
                ]
            },
            "187": {
                "label": "Acupuncture",
                "attributes": [
                    69,
                    20,
                    28,
                    78,
                    1
                ]
            },
            "194": {
                "label": "Hydrotherapy",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    78,
                    1
                ]
            },
            "474": {
                "label": "Therapeutic drinking regimen",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    78,
                    1
                ]
            },
            "472": {
                "label": "Cleopatra bath",
                "attributes": [
                    94,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "479": {
                "label": "Wellness centre",
                "attributes": [
                    97,
                    96,
                    94,
                    74,
                    75,
                    200,
                    69,
                    14,
                    26,
                    70,
                    20,
                    21,
                    39,
                    1,
                    45,
                    83,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "476": {
                "label": "Hydrojet massage",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    78,
                    1
                ]
            },
            "473": {
                "label": "Fango treatments",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    78,
                    1
                ]
            },
            "475": {
                "label": "Reflexology massage",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    78,
                    1
                ]
            },
            "467": {
                "label": "Qigong",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "466": {
                "label": "Acupressure",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "469": {
                "label": "Aromatherapy",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "470": {
                "label": "Medicinal baths",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    78,
                    1
                ]
            },
            "468": {
                "label": "Autogenic training",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "471": {
                "label": "Cellulite treatment",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "429": {
                "label": "Yacht",
                "attributes": []
            },
            "426": {
                "label": "Ferry",
                "attributes": []
            },
            "427": {
                "label": "House boat",
                "attributes": []
            },
            "432": {
                "label": "Mobile home",
                "attributes": []
            },
            "431": {
                "label": "Caravan",
                "attributes": []
            },
            "430": {
                "label": "Camper van",
                "attributes": []
            },
            "428": {
                "label": "Sailing boat",
                "attributes": []
            },
            "425": {
                "label": "Ship/boat",
                "attributes": []
            },
            "424": {
                "label": "Private flat",
                "attributes": []
            },
            "423": {
                "label": "Igloo",
                "attributes": []
            },
            "416": {
                "label": "Ranch",
                "attributes": []
            },
            "409": {
                "label": "Motel",
                "attributes": []
            },
            "421": {
                "label": "Hut",
                "attributes": []
            },
            "414": {
                "label": "Resort",
                "attributes": []
            },
            "407": {
                "label": "Inn",
                "attributes": []
            },
            "408": {
                "label": "Countryside hotel",
                "attributes": []
            },
            "415": {
                "label": "Farm",
                "attributes": []
            },
            "422": {
                "label": "Cave dwelling",
                "attributes": []
            },
            "417": {
                "label": "Horse ranch",
                "attributes": []
            },
            "419": {
                "label": "Holiday house",
                "attributes": []
            },
            "412": {
                "label": "Holiday complex",
                "attributes": []
            },
            "420": {
                "label": "Holiday flat",
                "attributes": []
            },
            "418": {
                "label": "Temple/monastery",
                "attributes": []
            },
            "413": {
                "label": "Apartment complex",
                "attributes": []
            },
            "410": {
                "label": "Pousada/Parador",
                "attributes": []
            },
            "411": {
                "label": "Palace/castle hotel",
                "attributes": []
            },
            "406": {
                "label": "Hotel garni",
                "attributes": []
            },
            "405": {
                "label": "Romantic hotel",
                "attributes": []
            },
            "404": {
                "label": "Hotel",
                "attributes": []
            },
            "278": {
                "label": "Lodge",
                "attributes": []
            },
            "277": {
                "label": "Hostel",
                "attributes": []
            },
            "281": {
                "label": "Residence",
                "attributes": []
            },
            "286": {
                "label": "Holiday home villa",
                "attributes": []
            },
            "287": {
                "label": "Holiday village",
                "attributes": []
            },
            "283": {
                "label": "Self-catering accommodation",
                "attributes": []
            },
            "274": {
                "label": "Guest house",
                "attributes": []
            },
            "264": {
                "label": "Club resort",
                "attributes": []
            },
            "271": {
                "label": "Hotel ship",
                "attributes": []
            },
            "266": {
                "label": "Cruise ship",
                "attributes": []
            },
            "270": {
                "label": "Finca",
                "attributes": []
            },
            "261": {
                "label": "Casino resort",
                "attributes": []
            },
            "254": {
                "label": "Apartment",
                "attributes": []
            },
            "260": {
                "label": "Campsite",
                "attributes": []
            },
            "258": {
                "label": "Bungalow complex",
                "attributes": []
            },
            "253": {
                "label": "Apartment hotel",
                "attributes": []
            },
            "256": {
                "label": "B & B",
                "attributes": []
            },
            "340": {
                "label": "Bus stop",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "307": {
                "label": "Train station",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "306": {
                "label": "Tourist attractions",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "291": {
                "label": "City centre",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "305": {
                "label": "Metro station",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "298": {
                "label": "Public transport connections",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "290": {
                "label": "Bus station",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "320": {
                "label": "Built in the year",
                "attributes": [
                    50,
                    1
                ]
            },
            "321": {
                "label": "Year of last renovation",
                "attributes": [
                    50,
                    1
                ]
            },
            "533": {
                "label": "Hotel classification (official)",
                "attributes": []
            },
            "326": {
                "label": "Category (recommended)",
                "attributes": [
                    56,
                    1
                ]
            },
            "325": {
                "label": "Category (official)",
                "attributes": [
                    56,
                    1
                ]
            },
            "89": {
                "label": "Beach",
                "attributes": [
                    97,
                    94,
                    93,
                    92,
                    14,
                    26,
                    35,
                    36,
                    15,
                    71,
                    72,
                    73,
                    22,
                    95,
                    33,
                    55,
                    54,
                    6,
                    195
                ]
            },
            "458": {
                "label": "Changing rooms",
                "attributes": [
                    94,
                    93,
                    92,
                    89,
                    75,
                    77,
                    81,
                    20,
                    21,
                    39,
                    29
                ]
            },
            "439": {
                "label": "Wicker beach chairs",
                "attributes": [
                    89,
                    75,
                    77,
                    81,
                    20,
                    21,
                    28,
                    39
                ]
            },
            "336": {
                "label": "Beach bar",
                "attributes": [
                    97,
                    75,
                    200,
                    77,
                    14,
                    26,
                    35,
                    36,
                    39,
                    49,
                    191,
                    192,
                    194,
                    195
                ]
            },
            "334": {
                "label": "Sun loungers on the beach",
                "attributes": [
                    93,
                    89,
                    75,
                    77,
                    81,
                    20,
                    21,
                    28,
                    39
                ]
            },
            "335": {
                "label": "Parasols on the beach",
                "attributes": [
                    93,
                    89,
                    77,
                    81,
                    20,
                    21,
                    28,
                    39
                ]
            },
            "337": {
                "label": "Airport reference",
                "attributes": [
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "511": {
                "label": "Accommodation temporarily closed",
                "attributes": [
                    192
                ]
            },
            "347": {
                "label": "Altitude AMSL",
                "attributes": [
                    64,
                    1
                ]
            },
            "332": {
                "label": "URL",
                "attributes": [
                    64,
                    1
                ]
            },
            "330": {
                "label": "Fax",
                "attributes": [
                    64,
                    1
                ]
            },
            "331": {
                "label": "E-mail",
                "attributes": [
                    64,
                    1
                ]
            },
            "329": {
                "label": "Phone",
                "attributes": [
                    64,
                    1
                ]
            },
            "328": {
                "label": "Address",
                "attributes": [
                    63,
                    65,
                    58,
                    59,
                    61,
                    60,
                    62
                ]
            },
            "327": {
                "label": "Hotel chain",
                "attributes": [
                    64,
                    1
                ]
            },
            "339": {
                "label": "Spa complex",
                "attributes": []
            },
            "338": {
                "label": "Design hotel",
                "attributes": []
            },
            "282": {
                "label": "Country house hotel",
                "attributes": []
            },
            "284": {
                "label": "Ski hotel",
                "attributes": []
            },
            "285": {
                "label": "Spa hotel",
                "attributes": []
            },
            "279": {
                "label": "Mountain hotel",
                "attributes": []
            },
            "280": {
                "label": "Mountain cabin",
                "attributes": []
            },
            "276": {
                "label": "Historic hotel",
                "attributes": []
            },
            "272": {
                "label": "Gay hotel",
                "attributes": []
            },
            "268": {
                "label": "Eco hotel",
                "attributes": []
            },
            "273": {
                "label": "Golf hotel",
                "attributes": []
            },
            "263": {
                "label": "Urban hotel",
                "attributes": []
            },
            "275": {
                "label": "Hiking hotel",
                "attributes": []
            },
            "267": {
                "label": "Bike hotel",
                "attributes": []
            },
            "262": {
                "label": "Hotel de charme",
                "attributes": []
            },
            "265": {
                "label": "Conference hotel",
                "attributes": []
            },
            "269": {
                "label": "Family-friendly hotel",
                "attributes": []
            },
            "255": {
                "label": "Beach hotel",
                "attributes": []
            },
            "259": {
                "label": "Business hotel",
                "attributes": []
            },
            "252": {
                "label": "Airport hotel",
                "attributes": []
            },
            "257": {
                "label": "Boutique hotel",
                "attributes": []
            },
            "251": {
                "label": "Adults-only hotel",
                "attributes": []
            },
            "316": {
                "label": "Number of rooms (total)",
                "attributes": [
                    49,
                    1
                ]
            },
            "318": {
                "label": "Number of suites",
                "attributes": [
                    49,
                    1
                ]
            },
            "317": {
                "label": "Number of studios",
                "attributes": [

                    49,
                    1
                ]
            },
            "310": {
                "label": "Number of bungalows",
                "attributes": [
                    49,
                    1
                ]
            },
            "309": {
                "label": "Number of apartments",
                "attributes": [
                    49,
                    1
                ]
            },
            "308": {
                "label": "Auxiliary building",
                "attributes": [
                    14,
                    26,
                    35,
                    36,
                    70,
                    15,
                    71,
                    49
                ]
            },
            "314": {
                "label": "Number of double rooms",
                "attributes": [
                    49,
                    1
                ]
            },
            "315": {
                "label": "Number of single rooms",
                "attributes": [
                    49,
                    1
                ]
            },
            "313": {
                "label": "Number of junior suites",
                "attributes": [
                    49,
                    1
                ]
            },
            "319": {
                "label": "Number of villas/houses",
                "attributes": [
                    49,
                    1
                ]
            },
            "311": {
                "label": "Storeys - main building",
                "attributes": [
                    49,
                    1
                ]
            },
            "312": {
                "label": "Storeys - adjacent building",
                "attributes": [
                    49,
                    1
                ]
            },
            "90": {
                "label": "Central location",
                "attributes": [
                    15
                ]
            },
            "91": {
                "label": "Quiet location",
                "attributes": []
            },
            "350": {
                "label": "Historic centre",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "352": {
                "label": "Out of town",
                "attributes": []
            },
            "351": {
                "label": "In the outskirts",
                "attributes": []
            },
            "348": {
                "label": "Lively location",
                "attributes": []
            },
            "353": {
                "label": "Rural location",
                "attributes": []
            },
            "349": {
                "label": "Car-free location",
                "attributes": []
            },
            "323": {
                "label": "Located on a main road",
                "attributes": [
                    14
                ]
            },
            "294": {
                "label": "Golf course",
                "attributes": [
                    91,
                    69,
                    14,
                    26,
                    15,
                    71,
                    72,
                    73,
                    1
                ]
            },
            "296": {
                "label": "Nightclub",
                "attributes": [
                    69,
                    14,
                    26,
                    15,
                    71,
                    72,
                    73,
                    1
                ]
            },
            "299": {
                "label": "Restaurant",
                "attributes": [
                    69,
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "302": {
                "label": "Shopping opportunities",
                "attributes": [
                    69,
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "288": {
                "label": "Bar/pub",
                "attributes": [
                    69,
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "444": {
                "label": "Internet café",
                "attributes": [
                    27,
                    57,
                    74,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "295": {
                "label": "Lake",
                "attributes": [
                    97,
                    14,
                    26,
                    36,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "293": {
                "label": "Forest",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "297": {
                "label": "Park",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "301": {
                "label": "Sea",
                "attributes": [
                    14,
                    26,
                    35,
                    36,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "300": {
                "label": "River",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "289": {
                "label": "Beach",
                "attributes": [
                    14,
                    26,
                    35,
                    36,
                    15,
                    71,
                    72,
                    73,
                    6
                ]
            },
            "304": {
                "label": "Ski lift",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "303": {
                "label": "Ski resort",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "292": {
                "label": "Cross-country ski resort",
                "attributes": [
                    14,
                    26,
                    15,
                    71,
                    72,
                    73
                ]
            },
            "480": {
                "label": "Cross-country ski trail",
                "attributes": [
                    89,
                    77,
                    14,
                    26,
                    70,
                    15,
                    71,
                    72,
                    73,
                    49
                ]
            },
            "532": {
                "label": "Check-out by",
                "attributes": [
                    199,
                    1
                ],
                invisible: true
            },
            "531": {
                "label": "Check-in from",
                "attributes": [
                    199,
                    1
                ],
                invisible: true
            },
            "88": {
                "label": "WiFi",
                "attributes": [
                    96,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "87": {
                "label": "Disability-friendly",
                "attributes": []
            },
            "85": {
                "label": "Cloakroom",
                "attributes": [
                    20,
                    192
                ]
            },
            "84": {
                "label": "Wake-up service",
                "attributes": [
                    28
                ]
            },
            "81": {
                "label": "Transfer service",
                "attributes": [
                    74,
                    75,
                    200,
                    20,
                    21,
                    28,
                    39,
                    1,
                    191,
                    192,
                    194,
                    195,
                    197
                ]
            },
            "72": {
                "label": "Smoke/fire detector",
                "attributes": []
            },
            "71": {
                "label": "Hotel shuttle service",
                "attributes": [
                    74,
                    75,
                    200,
                    20,
                    21,
                    28,
                    1,
                    191,
                    192
                ]
            },
            "69": {
                "label": "Security service",
                "attributes": [
                    74,
                    192
                ]
            },
            "67": {
                "label": "Safe",
                "attributes": [
                    20,
                    21,
                    28,
                    1,
                    49,
                    192
                ]
            },
            "62": {
                "label": "Reception",
                "attributes": [
                    74,
                    75,
                    200,
                    45,
                    11,
                    17,
                    66,
                    29,
                    191,
                    194
                ]
            },
            "63": {
                "label": "Lobby",
                "attributes": [
                    45,
                    194,
                    195
                ]
            },
            "55": {
                "label": "Hotel doctor",
                "attributes": [
                    89,
                    74,
                    75,
                    20,
                    21,
                    78,
                    11,
                    17,
                    66,
                    192
                ]
            },
            "47": {
                "label": "Medical assistance",
                "attributes": [
                    74,
                    75,
                    20,
                    21,
                    28,
                    39,
                    78,
                    1,
                    11,
                    17,
                    66,
                    192
                ]
            },
            "45": {
                "label": "Laundry service",
                "attributes": [
                    96,
                    74,
                    75,
                    200,
                    20,
                    21,
                    28,
                    39,
                    1,
                    49,
                    192
                ]
            },
            "44": {
                "label": "Internet access",
                "attributes": [
                    96,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "39": {
                "label": "Garage",
                "attributes": [
                    93,
                    89,
                    69,
                    14,
                    26,
                    70,
                    20,
                    21,
                    28,
                    39,
                    6,
                    88,
                    1,
                    49,
                    76
                ]
            },
            "38": {
                "label": "Bellboy service",
                "attributes": [
                    74,
                    200
                ]
            },
            "34": {
                "label": "Currency exchange desk",
                "attributes": [
                    75,
                    200,
                    191,
                    192,
                    194,
                    195
                ],
                "icon": RiExchangeBoxLine
            },
            "33": {
                "label": "Lift",
                "attributes": [
                    49,
                    192,
                    194,
                    195
                ],
                "icon": MdOutlineElevator
            },
            "27": {
                "label": "Coin-operated laundry",
                "attributes": [
                    96,
                    92,
                    74,
                    20,
                    28,
                    39,
                    1,
                    49,
                    191,
                    192,
                    194,
                    195
                ]
            },
            "25": {
                "label": "Check-in/out service",
                "attributes": [
                    74,
                    75,
                    200,
                    29,
                    191
                ]
            },
            "22": {
                "label": "Car park",
                "icon": AiOutlineCar,
                "attributes": [
                    96,
                    93,
                    92,
                    89,
                    69,
                    14,
                    26,
                    20,
                    21,
                    28,
                    39,
                    44,
                    6,
                    88,
                    1,
                    49,
                    76,
                    192
                ]
            },
            "23": {
                "label": "Cash machine",
                "icon": BsCashCoin,
                "attributes": [
                    49
                ]
            },
            "21": {
                "label": "Car rental",
                "attributes": [
                    75,
                    28,
                    39,
                    1,
                    29,
                    192
                ]
            },
            "16": {
                "label": "Bicycle storage area",
                "attributes": [
                    20,
                    21,
                    28,
                    6,
                    1,
                    49,
                    76
                ]
            },
            "17": {
                "label": "Multilingual staff",
                "attributes": [
                    75,
                    11,
                    17,
                    66,
                    192
                ]
            },
            "15": {
                "label": "Bicycle hire",
                "attributes": [
                    75,
                    20,
                    21,
                    28,
                    39,
                    1,
                    29,
                    191,
                    192
                ]
            },
            "11": {
                "label": "Baggage storage service",
                "attributes": [
                    74,
                    75,
                    200,
                    20,
                    21,
                    28,
                    1,
                    192
                ]
            },
            "10": {
                "label": "Babysitter",
                "attributes": [
                    74,
                    200,
                    20,
                    21,
                    28,
                    39,
                    1,
                    11,
                    17,
                    66,
                    192
                ]
            },
            "8": {
                "label": "Air conditioning",
                "icon": BsSnow,
                "attributes": [
                    74,
                    75,
                    192
                ]
            },
            "346": {
                "label": "Wheelchair-accessible",
                "attributes": [
                    20,
                    21
                ]
            },
            "322": {
                "label": "Foyer",
                "attributes": [
                    45,
                    194,
                    195
                ]
            },
            "455": {
                "label": "Lounge",
                "attributes": [
                    92,
                    27,
                    57,
                    45,
                    76,
                    191,
                    192,
                    193,
                    194,
                    195
                ]
            },
            "440": {
                "label": "Smoking area",
                "attributes": [
                    45,
                    192,
                    193,
                    195
                ]
            },
            "449": {
                "label": "Roof terrace",
                "attributes": [
                    97,
                    92,
                    77,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "441": {
                "label": "Non-smoking area",
                "attributes": [
                    195
                ]
            },
            "73": {
                "label": "Snack bar",
                "attributes": [
                    74,
                    75,
                    1,
                    49,
                    191,
                    192,
                    194,
                    195,
                    197
                ]
            },
            "66": {
                "label": "Room service",
                "attributes": [
                    96,
                    74,
                    75,
                    200,
                    20,
                    21,
                    28,
                    1,
                    191,
                    192
                ]
            },
            "64": {
                "label": "Dining area",
                "attributes": [
                    27,
                    57,
                    75,
                    7,
                    2,
                    25,
                    45,
                    46,
                    49,
                    76,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197
                ]
            },
            "65": {
                "label": "Restaurant",
                "attributes": [
                    27,
                    57,
                    74,
                    75,
                    200,
                    7,
                    2,
                    25,
                    1,
                    45,
                    46,
                    49,
                    76,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197
                ]
            },
            "61": {
                "label": "Pub/Tavern",
                "attributes": [
                    27,
                    57,
                    74,
                    75,
                    200,
                    1,
                    49,
                    76,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197
                ]
            },
            "20": {
                "label": "Café",
                "attributes": [
                    27,
                    57,
                    75,
                    200,
                    1,
                    45,
                    46,
                    49,
                    76,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197
                ]
            },
            "18": {
                "label": "Breakfast room",
                "attributes": [
                    27,
                    57,
                    75,
                    16,
                    23,
                    7,
                    2,
                    25,
                    45,
                    46,
                    49,
                    76,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197
                ]
            },
            "14": {
                "label": "Bar/pub",
                "icon": BiDrink,
                "attributes": [
                    74,
                    75,
                    200,
                    1,
                    49,
                    76,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197
                ]
            },
            "450": {
                "label": "Lobby bar",
                "attributes": [
                    27,
                    57,
                    74,
                    75,
                    200,
                    45,
                    76,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197
                ]
            },
            "451": {
                "label": "Piano bar",
                "attributes": [
                    27,
                    57,
                    75,
                    200,
                    76,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197
                ]
            },
            "443": {
                "label": "Drinks machine",
                "attributes": [
                    192
                ]
            },
            "83": {
                "label": "TV room",
                "attributes": [
                    74,
                    75,
                    20,
                    21,
                    43,
                    34,
                    8,
                    84,
                    85,
                    45,
                    49,
                    76,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "79": {
                "label": "Tour desk",
                "attributes": [
                    75,
                    200,
                    39,
                    29,
                    191,
                    192,
                    194,
                    195
                ]
            },
            "77": {
                "label": "Supermarket",
                "attributes": [
                    74,
                    75,
                    200,
                    39,
                    49,
                    29,
                    191,
                    192,
                    194,
                    195
                ]
            },
            "75": {
                "label": "Souvenir shop",
                "attributes": [
                    75,
                    200,
                    39,
                    49,
                    29,
                    191,
                    192,
                    194,
                    195
                ]
            },
            "70": {
                "label": "Shops",
                "attributes": [
                    75,
                    200,
                    39,
                    49,
                    29,
                    194,
                    195
                ]
            },
            "57": {
                "label": "Playroom",
                "attributes": [
                    75,
                    20,
                    45,
                    49,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "56": {
                "label": "Playground",
                "attributes": [
                    92,
                    75,
                    20,
                    44,
                    49,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195
                ]
            },
            "49": {
                "label": "Nightclub",
                "attributes": [
                    92,
                    75,
                    200,
                    45,
                    76,
                    191,
                    192,
                    194,
                    195
                ]
            },
            "48": {
                "label": "Newspaper stand",
                "attributes": [
                    75,
                    39,
                    49,
                    29,
                    191,
                    192,
                    194,
                    195
                ]
            },
            "46": {
                "label": "Library",
                "attributes": [
                    75,
                    200,
                    20,
                    1,
                    45,
                    49,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "42": {
                "label": "Hairdressing salon",
                "attributes": [
                    75,
                    200,
                    20,
                    21,
                    28,
                    39,
                    1,
                    49,
                    29,
                    191,
                    192,
                    194,
                    195,
                    197
                ]
            },
            "41": {
                "label": "Golf desk",
                "attributes": [
                    75,
                    200,
                    191,
                    192,
                    194,
                    195
                ]
            },
            "36": {
                "label": "Fireplace",
                "attributes": [
                    49
                ]
            },
            "32": {
                "label": "DVD hire service",
                "attributes": [
                    74,
                    75,
                    20,
                    21,
                    28,
                    39,
                    1,
                    191,
                    192,
                    194,
                    195
                ]
            },
            "31": {
                "label": "Disco",
                "attributes": [
                    92,
                    75,
                    200,
                    20,
                    1,
                    45,
                    49,
                    76,
                    191,
                    192,
                    193,
                    194,
                    195
                ]
            },
            "24": {
                "label": "Casino",
                "attributes": [
                    92,
                    75,
                    200,
                    20,
                    1,
                    45,
                    49,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "12": {
                "label": "Balcony",
                "attributes": [
                    44,
                    49,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "13": {
                "label": "Banquet hall",
                "attributes": [
                    75,
                    20,
                    21,
                    28,
                    44,
                    45,
                    49,
                    76,
                    191,
                    192,
                    194,
                    195,
                    196,
                    197
                ]
            },
            "9": {
                "label": "Theatre hall",
                "attributes": [
                    75,
                    20,
                    28,
                    45,
                    49,
                    76,
                    191,
                    192,
                    194,
                    195,
                    196,
                    197
                ]
            },
            "456": {
                "label": "Daily newspaper",
                "attributes": [
                    20,
                    21,
                    28,
                    11,
                    17,
                    66,
                    192
                ]
            },
            "453": {
                "label": "Cinema",
                "attributes": [
                    75,
                    200,
                    21,
                    45,
                    11,
                    17,
                    66,
                    49,
                    76,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197
                ]
            },
            "82": {
                "label": "Translator",
                "attributes": [
                    20,
                    21,
                    28,
                    39
                ]
            },
            "68": {
                "label": "Secretarial service",
                "attributes": [
                    200,
                    20,
                    21,
                    28,
                    39
                ]
            },
            "60": {
                "label": "Beamer",
                "attributes": [
                    81,
                    20,
                    21,
                    28,
                    49
                ]
            },
            "54": {
                "label": "Photocopier",
                "attributes": [
                    81,
                    20,
                    28,
                    49
                ]
            },
            "51": {
                "label": "Projector",
                "attributes": [
                    81,
                    20,
                    21,
                    28,
                    49
                ]
            },
            "37": {
                "label": "Flip chart and pens",
                "attributes": [
                    20,
                    21,
                    28,
                    49
                ]
            },
            "35": {
                "label": "Fax",
                "attributes": [
                    81,
                    20,
                    21,
                    28,
                    39
                ]
            },
            "28": {
                "label": "Conference room",
                "icon": BsMic,
                "attributes": [
                    20,
                    21,
                    28,
                    44,
                    45,
                    49,
                    76,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "29": {
                "label": "Congress services",
                "attributes": [
                    200,
                    20,
                    21,
                    28,
                    39
                ]
            },
            "19": {
                "label": "Business centre",
                "icon": BsBuilding,
                "attributes": [
                    74,
                    200,
                    20,
                    21,
                    28,
                    45,
                    49,
                    76,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "86": {
                "label": "Waterslide",
                "attributes": [
                    75,
                    20,
                    49,
                    192
                ]
            },
            "80": {
                "label": "Bath towels",
                "attributes": [
                    81,
                    20,
                    21,
                    28,
                    1
                ]
            },
            "78": {
                "label": "Terrace",
                "attributes": [
                    97,
                    92,
                    44,
                    49,
                    192,
                    194,
                    195
                ]
            },
            "76": {
                "label": "Sun terrace",
                "attributes": [
                    97,
                    20,
                    44,
                    49,
                    192,
                    194,
                    195
                ]
            },
            "59": {
                "label": "Poolside bar",
                "attributes": [
                    97,
                    75,
                    200,
                    77,
                    20,
                    49,
                    29,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "58": {
                "label": "Pool",
                "attributes": [
                    97,
                    92,
                    75,
                    200,
                    20,
                    44,
                    6,
                    51,
                    52,
                    53,
                    49,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "52": {
                "label": "Parasols",
                "attributes": [
                    89,
                    77,
                    81,
                    20,
                    21,
                    1,
                    49,
                    29,
                    197
                ]
            },
            "50": {
                "label": "Outdoor pool",
                "attributes": [
                    97,
                    75,
                    200,
                    77,
                    20,
                    44,
                    6,
                    51,
                    52,
                    53,
                    49,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "43": {
                "label": "Indoor pool",
                "attributes": [
                    94,
                    92,
                    75,
                    200,
                    20,
                    21,
                    44,
                    6,
                    51,
                    52,
                    53,
                    49,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "40": {
                "label": "Garden",
                "attributes": [
                    97,
                    92,
                    44
                ]
            },
            "30": {
                "label": "Sun loungers",
                "attributes": [
                    89,
                    81,
                    20,
                    21,
                    28,
                    49,
                    197
                ],
                "icon": BsSun
            },
            "26": {
                "label": "Children's pool",
                "attributes": [
                    75,
                    200,
                    20,
                    44,
                    6,
                    68,
                    51,
                    52,
                    53,
                    49,
                    191,
                    192,
                    193,
                    194,
                    195,
                    197
                ]
            },
            "457": {
                "label": "Sunbathing area",
                "attributes": [
                    97,
                    94,
                    44
                ]
            },
            "459": {
                "label": "Changing rooms",
                "attributes": [
                    94,
                    92,
                    20,
                    21,
                    29
                ]
            },
            "341": {
                "label": "Balcony or terrace",
                "attributes": [
                    96,
                    89,
                    20,
                    21,
                    28,
                    37,
                    44,
                    49
                ]
            },
            "182": {
                "label": "Wheelchair-accessible rooms",
                "attributes": [
                    28,
                    49
                ]
            },
            "173": {
                "label": "Terrace",
                "attributes": [
                    96,
                    89,
                    20,
                    21,
                    28,
                    37,
                    44,
                    49
                ]
            },
            "167": {
                "label": "Size in sqm",
                "attributes": [
                    64,
                    1
                ],
                invisible: true
            },
            "170": {
                "label": "Smoking room",
                "attributes": [
                    28,
                    44,
                    45,
                    49
                ]
            },
            "153": {
                "label": "Lounge",
                "attributes": [
                    96,
                    45,
                    76
                ]
            },
            "158": {
                "label": "Non-smoking room",
                "attributes": [
                    28,
                    44,
                    45,
                    49
                ]
            },
            "152": {
                "label": "Living room",
                "attributes": [
                    96,
                    44,
                    45,
                    83,
                    49
                ]
            },
            "141": {
                "label": "Family room",
                "attributes": [
                    96,
                    27,
                    57,
                    44,
                    45,
                    49
                ]
            },
            "123": {
                "label": "Balcony",
                "attributes": [
                    96,
                    89,
                    20,
                    21,
                    28,
                    37,
                    44,
                    49
                ]
            },
            "125": {
                "label": "Bathroom",
                "attributes": [
                    44,
                    45,
                    83,
                    49
                ]
            },
            "448": {
                "label": "Loggia",
                "attributes": [
                    96,
                    44
                ]
            },
            "447": {
                "label": "Veranda",
                "attributes": [
                    96
                ]
            },
            "442": {
                "label": "Dining area",
                "attributes": [
                    96,
                    37,
                    44,
                    46
                ]
            },
            "445": {
                "label": "Roof terrace",
                "attributes": [
                    96,
                    44
                ]
            },
            "446": {
                "label": "Communal terrace",
                "attributes": [
                    96
                ]
            },
            "121": {
                "label": "Alarm clock",
                "attributes": [
                    20,
                    21,
                    28
                ]
            },
            "122": {
                "label": "Background music",
                "attributes": [
                    96
                ]
            },
            "120": {
                "label": "Air conditioning",
                "attributes": [
                    96,
                    75,
                    20,
                    21,
                    28,
                    48,
                    47,
                    29
                ]
            },
            "118": {
                "label": "Plug socket adapter",
                "attributes": [
                    20,
                    21,
                    28
                ]
            },
            "185": {
                "label": "WiFi",
                "attributes": [
                    96,
                    20,
                    21,
                    28,
                    1
                ]
            },
            "186": {
                "label": "Desk",
                "attributes": [
                    96
                ]
            },
            "179": {
                "label": "Voltage",
                "attributes": [
                    [
                        64,
                        1
                    ]
                ]
            },
            "176": {
                "label": "TV",
                "attributes": [
                    96,
                    20,
                    21,
                    28,
                    43,
                    34,
                    30,
                    8,
                    19,
                    84,
                    85,
                    49
                ]
            },
            "168": {
                "label": "Slippers",
                "attributes": [
                    96,
                    28,
                    1
                ]
            },
            "177": {
                "label": "Fan",
                "attributes": [
                    96,
                    20,
                    21,
                    28
                ]
            },
            "169": {
                "label": "Smoke alarm",
                "attributes": []
            },
            "175": {
                "label": "Trouser press",
                "attributes": [
                    96,
                    81,
                    28
                ]
            },
            "174": {
                "label": "Tiled floor",
                "attributes": []
            },
            "178": {
                "label": "Games console",
                "attributes": [
                    96,
                    81,
                    20,
                    21,
                    28
                ]
            },
            "181": {
                "label": "Welcome gift",
                "attributes": [
                    96
                ]
            },
            "162": {
                "label": "Radio",
                "attributes": [
                    96,
                    28,
                    84,
                    85
                ]
            },
            "159": {
                "label": "Telephone",
                "attributes": [
                    20,
                    13,
                    49
                ]
            },
            "156": {
                "label": "Minibar",
                "attributes": [
                    96,
                    20,
                    21,
                    28
                ]
            },
            "345": {
                "label": "Stove",
                "attributes": [
                    96,
                    20,
                    21,
                    28
                ]
            },
            "155": {
                "label": "Mini fridge",
                "attributes": [
                    96
                ]
            },
            "163": {
                "label": "Safe",
                "attributes": [
                    96,
                    20,
                    21,
                    28
                ]
            },
            "157": {
                "label": "Daily paper",
                "attributes": [
                    96,
                    20,
                    21,
                    28,
                    1,
                    11,
                    17,
                    66
                ]
            },
            "146": {
                "label": "Heating",
                "attributes": [
                    20,
                    21,
                    28,
                    48,
                    83,
                    47
                ]
            },
            "139": {
                "label": "Ironing set",
                "attributes": [
                    96,
                    81,
                    28
                ]
            },
            "138": {
                "label": "DVD player",
                "attributes": [
                    96,
                    81,
                    20,
                    21,
                    28,
                    49
                ]
            },
            "142": {
                "label": "Cleaning on departure",
                "attributes": [
                    20,
                    28,
                    1
                ]
            },
            "147": {
                "label": "Stereo system",
                "attributes": [
                    96,
                    81,
                    28
                ]
            },
            "148": {
                "label": "Internet access",
                "attributes": [
                    96,
                    20,
                    21,
                    28,
                    1
                ]
            },
            "144": {
                "label": "Turndown service",
                "attributes": [
                    96,
                    200,
                    20,
                    21,
                    28,
                    1
                ]
            },
            "130": {
                "label": "CD player",
                "attributes": [
                    96,
                    81,
                    28
                ]
            },
            "129": {
                "label": "Carpeted floor",
                "attributes": []
            },
            "461": {
                "label": "Kettle",
                "attributes": [
                    96,
                    28
                ]
            },
            "452": {
                "label": "Parquet floor",
                "attributes": []
            },
            "460": {
                "label": "Toaster",
                "attributes": [
                    96,
                    28
                ]
            },
            "119": {
                "label": "Extra bed",
                "attributes": [
                    96,
                    20,
                    21,
                    28,
                    49
                ]
            },
            "171": {
                "label": "Sofa-bed",
                "attributes": [
                    96,
                    49,
                    86,
                    87
                ]
            },
            "161": {
                "label": "Queen-size bed",
                "attributes": [
                    96,
                    49
                ]
            },
            "137": {
                "label": "Double bed",
                "attributes": [
                    96,
                    49
                ]
            },
            "149": {
                "label": "King-size bed",
                "attributes": [
                    96,
                    49
                ]
            },
            "131": {
                "label": "Cot",
                "attributes": [
                    96,
                    20,
                    21,
                    28,
                    49
                ]
            },
            "132": {
                "label": "Pillow selection",
                "attributes": [
                    96,
                    28
                ]
            },
            "127": {
                "label": "Separate bedrooms",
                "attributes": [
                    96,
                    45,
                    49
                ]
            },
            "184": {
                "label": "Whirlpool bath",
                "attributes": [
                    96,
                    49
                ]
            },
            "183": {
                "label": "Wheelchair-accessible bathroom",
                "attributes": [
                    96,
                    28,
                    44,
                    45,
                    49
                ]
            },
            "166": {
                "label": "Shower",
                "attributes": [
                    96,
                    49
                ]
            },
            "165": {
                "label": "Magnifying mirror",
                "attributes": [
                    96,
                    81,
                    20,
                    21,
                    28
                ]
            },
            "160": {
                "label": "Telephone",
                "attributes": [
                    96,
                    81,
                    20,
                    28
                ]
            },
            "145": {
                "label": "Hairdryer",
                "attributes": [
                    96,
                    81,
                    20,
                    21,
                    28
                ]
            },
            "140": {
                "label": "Electric shaver",
                "attributes": [
                    96,
                    81,
                    20,
                    21,
                    28
                ]
            },
            "128": {
                "label": "Bidet",
                "attributes": [
                    96,
                    49
                ]
            },
            "126": {
                "label": "Bathtub",
                "attributes": [
                    96,
                    49
                ]
            },
            "124": {
                "label": "Bathrobe",
                "attributes": [
                    96,
                    49
                ]
            },
            "135": {
                "label": "Personal care products",
                "attributes": [
                    96,
                    20,
                    21,
                    28
                ]
            },
            "133": {
                "label": "Towel selection",
                "attributes": [
                    96
                ]
            },
            "402": {
                "label": "Baby tub",
                "attributes": [
                    96,
                    20,
                    21,
                    28
                ]
            },
            "180": {
                "label": "Washing machine",
                "attributes": [
                    96,
                    20,
                    21,
                    28
                ]
            },
            "172": {
                "label": "Tea and coffee making equipment",
                "attributes": [
                    96,
                    81,
                    28
                ]
            },
            "154": {
                "label": "Microwave",
                "attributes": [
                    96,
                    20,
                    21,
                    28
                ]
            },
            "150": {
                "label": "Kitchen",
                "attributes": [
                    96,
                    45,
                    46
                ]
            },
            "151": {
                "label": "Kitchenette",
                "attributes": [
                    96,
                    44,
                    46
                ]
            },
            "143": {
                "label": "Fridge",
                "attributes": [
                    96,
                    20,
                    21,
                    28
                ]
            },
            "136": {
                "label": "Dishwasher",
                "attributes": [
                    96,
                    20,
                    21,
                    28
                ]
            },
            "134": {
                "label": "Stove",
                "attributes": [
                    96,
                    20,
                    21,
                    28
                ]
            },
            "343": {
                "label": "Oven",
                "attributes": [
                    96,
                    20,
                    21,
                    28
                ]
            },
            "344": {
                "label": "Freezer",
                "attributes": [
                    96,
                    20,
                    21,
                    28
                ]
            },
            "462": {
                "label": "Tumble dryer",
                "attributes": [
                    96
                ]
            },
            "234": {
                "label": "Safaris",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "242": {
                "label": "Squash",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "245": {
                "label": "Tennis",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    79,
                    80,
                    1,
                    49
                ]
            },
            "231": {
                "label": "Paragliding",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39
                ]
            },
            "244": {
                "label": "Table tennis",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "230": {
                "label": "Paddle",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "233": {
                "label": "Putting green",
                "attributes": [
                    92,
                    91,
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "219": {
                "label": "Golf",
                "attributes": [
                    92,
                    91,
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1,
                    49
                ]
            },
            "217": {
                "label": "Darts",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "218": {
                "label": "Fishing",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "223": {
                "label": "Horse riding",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "216": {
                "label": "Curling",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "222": {
                "label": "Handball",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "227": {
                "label": "Crazy golf",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1,
                    194,
                    195
                ]
            },
            "221": {
                "label": "Gymnastics",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    78,
                    1
                ]
            },
            "229": {
                "label": "Nordic walking",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "220": {
                "label": "Gym",
                "attributes": [
                    92,
                    90,
                    74,
                    200,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1,
                    45,
                    49,
                    191,
                    192,
                    193,
                    194,
                    195
                ]
            },
            "212": {
                "label": "Boccia",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "211": {
                "label": "Pool/billiards",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1,
                    49
                ]
            },
            "213": {
                "label": "Bowling",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "202": {
                "label": "Aerobics",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "206": {
                "label": "Badminton",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "208": {
                "label": "Basketball",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "205": {
                "label": "Archery",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "210": {
                "label": "Cycling/mountain biking",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "250": {
                "label": "Yoga",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "246": {
                "label": "Volleyball",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "477": {
                "label": "Hiking",
                "attributes": [
                    90
                ]
            },
            "478": {
                "label": "Jogging",
                "attributes": [
                    90,
                    69
                ]
            },
            "463": {
                "label": "Pilates",
                "attributes": [
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "464": {
                "label": "Table football",
                "attributes": [
                    69,
                    20,
                    21,
                    1,
                    49
                ]
            },
            "235": {
                "label": "Sailing",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "236": {
                "label": "Diving",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "240": {
                "label": "Snorkelling",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "243": {
                "label": "Surfing",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "232": {
                "label": "Paddle boating",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "226": {
                "label": "Kitesurfing",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "214": {
                "label": "Canoeing",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "225": {
                "label": "Kayaking",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "224": {
                "label": "Jet skiing",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39
                ]
            },
            "215": {
                "label": "Catamaraning",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "228": {
                "label": "Motorboat",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39
                ]
            },
            "204": {
                "label": "Aquafit",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "203": {
                "label": "Aqua aerobics",
                "attributes": [
                    90,
                    69,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "209": {
                "label": "Beach volleyball",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "207": {
                "label": "Banana boat",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "249": {
                "label": "Windsurfing",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "247": {
                "label": "Water skiing",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "465": {
                "label": "Parasailing",
                "attributes": [
                    90,
                    70,
                    20,
                    21,
                    28,
                    39
                ]
            },
            "248": {
                "label": "Other watersports",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "237": {
                "label": "Ski pass",
                "attributes": [
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "238": {
                "label": "Skiing",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "241": {
                "label": "Snowboarding",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39
                ]
            },
            "239": {
                "label": "Sledging",
                "attributes": [
                    90,
                    20,
                    21,
                    28,
                    39,
                    1
                ]
            },
            "111": {
                "label": "Snacks",
                "attributes": [
                    96,
                    200,
                    20,
                    21,
                    28,
                    67,
                    1,
                    198
                ]
            },
            "105": {
                "label": "Lunch",
                "attributes": [
                    96,
                    200,
                    20,
                    21,
                    28,
                    67,
                    7,
                    2,
                    25,
                    1,
                    198
                ]
            },
            "103": {
                "label": "Half board",
                "attributes": [
                    96,
                    20,
                    28,
                    7,
                    2,
                    25,
                    1,
                    198
                ]
            },
            "100": {
                "label": "Dinner",
                "attributes": [
                    96,
                    200,
                    20,
                    21,
                    28,
                    7,
                    2,
                    25,
                    1,
                    198
                ]
            },
            "101": {
                "label": "Full board",
                "attributes": [
                    96,
                    28,
                    7,
                    2,
                    25,
                    1,
                    198
                ]
            },
            "97": {
                "label": "Brunch",
                "attributes": [
                    96,
                    200,
                    20,
                    21,
                    28,
                    7,
                    2,
                    25,
                    1,
                    198
                ]
            },
            "96": {
                "label": "Breakfast",
                "attributes": [
                    96,
                    200,
                    20,
                    21,
                    28,
                    67,
                    16,
                    23,
                    7,
                    2,
                    25,
                    10,
                    18,
                    82,
                    1,
                    198
                ]
            },
            "94": {
                "label": "All-inclusive plus",
                "attributes": [
                    96,
                    200,
                    7,
                    2,
                    25
                ]
            },
            "95": {
                "label": "B & B",
                "attributes": [
                    96
                ]
            },
            "92": {
                "label": "All-inclusive",
                "attributes": [
                    96,
                    200,
                    7,
                    2,
                    25
                ]
            },
            "324": {
                "label": "Drinks included",
                "attributes": [
                    96,
                    200,
                    1
                ]
            },
            "115": {
                "label": "Welcome drink",
                "attributes": [
                    96,
                    1
                ]
            },
            "114": {
                "label": "Vegetarian meals",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "112": {
                "label": "Alcohol-free drinks",
                "attributes": [
                    20,
                    21,
                    1
                ]
            },
            "113": {
                "label": "Special deals",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "110": {
                "label": "Live cooking",
                "attributes": [
                    20,
                    21,
                    28,
                    1,
                    192,
                    194,
                    195,
                    197
                ]
            },
            "108": {
                "label": "Picnic",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "109": {
                "label": "Room service",
                "attributes": [
                    96,
                    74,
                    75,
                    200,
                    20,
                    21,
                    28,
                    1,
                    29
                ]
            },
            "106": {
                "label": "Minibar",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "107": {
                "label": "Own brands",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "104": {
                "label": "International brands",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "102": {
                "label": "Gluten-free meals",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "98": {
                "label": "Children's meals",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "99": {
                "label": "Diet meals",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "93": {
                "label": "Alcoholic drinks",
                "attributes": [
                    20,
                    28,
                    1
                ]
            },
            "376": {
                "label": "Halal meals",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "377": {
                "label": "Kosher meals",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "434": {
                "label": "Food combining",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "436": {
                "label": "Organic food",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "437": {
                "label": "Baby food",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "435": {
                "label": "Whole/Unprocessed foods",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "378": {
                "label": "Vegan meals",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "379": {
                "label": "Lactose-free meals",
                "attributes": [
                    20,
                    21,
                    28,
                    1
                ]
            },
            "397": {
                "label": "Mountain travelers",
                "attributes": []
            },
            "381": {
                "label": "Club travelers",
                "attributes": []
            },
            "385": {
                "label": "Adults only",
                "attributes": []
            },
            "403": {
                "label": "Singles with child",
                "attributes": []
            },
            "438": {
                "label": "Vegans",
                "attributes": []
            },
            "433": {
                "label": "Short-term travelers",
                "attributes": []
            },
            "395": {
                "label": "Singles",
                "attributes": []
            },
            "396": {
                "label": "Cyclists",
                "attributes": []
            },
            "398": {
                "label": "Naturists",
                "attributes": []
            },
            "392": {
                "label": "Gay-Friendly",
                "attributes": []
            },
            "399": {
                "label": "Nature lovers",
                "attributes": []
            },
            "391": {
                "label": "Food travelers",
                "attributes": []
            },
            "394": {
                "label": "Long-term travelers",
                "attributes": []
            },
            "400": {
                "label": "Wellness travelers",
                "attributes": []
            },
            "393": {
                "label": "Wedding travelers",
                "attributes": []
            },
            "401": {
                "label": "Seminar and convention travelers",
                "attributes": []
            },
            "389": {
                "label": "Families",
                "attributes": []
            },
            "390": {
                "label": "Golf players",
                "attributes": []
            },
            "380": {
                "label": "Young people",
                "attributes": []
            },
            "382": {
                "label": "Beach travelers",
                "attributes": []
            },
            "386": {
                "label": "City travelers",
                "attributes": []
            },
            "388": {
                "label": "Cultural travelers",
                "attributes": []
            },
            "383": {
                "label": "Backpackers",
                "attributes": []
            },
            "387": {
                "label": "Business travelers",
                "attributes": []
            },
            "384": {
                "label": "Sports and active travelers",
                "attributes": []
            },
            "454": {
                "label": "Pharmacy",
                "attributes": [
                    74,
                    75,
                    200,
                    29,
                    192,
                    194,
                    195
                ]
            },
            "164": {
                "label": "Sea view",
                "attributes": [
                    96,
                    14,
                    38
                ]
            },
            "364": {
                "label": "Lake view",
                "attributes": [
                    96,
                    38
                ]
            },
            "375": {
                "label": "Forest view",
                "attributes": [
                    96,
                    38
                ]
            },
            "363": {
                "label": "Countryside view",
                "attributes": [
                    96,
                    38
                ]
            },
            "365": {
                "label": "Mountain view",
                "attributes": [
                    96,
                    38
                ]
            },
            "366": {
                "label": "Park view",
                "attributes": [
                    96,
                    38
                ]
            },
            "368": {
                "label": "Pool view",
                "attributes": [
                    96,
                    38
                ]
            },
            "370": {
                "label": "River view",
                "attributes": [
                    96,
                    38
                ]
            },
            "374": {
                "label": "Beach view",
                "attributes": [
                    96,
                    38
                ]
            },
            "367": {
                "label": "Piste view",
                "attributes": [
                    96,
                    38
                ]
            },
            "371": {
                "label": "Street view",
                "attributes": [
                    96,
                    38
                ]
            },
            "362": {
                "label": "Lagoon view",
                "attributes": [
                    96,
                    38
                ]
            },
            "369": {
                "label": "Pyramid view",
                "attributes": [
                    96,
                    38
                ]
            },
            "372": {
                "label": "Airport view",
                "attributes": [
                    96,
                    38
                ]
            },
            "373": {
                "label": "Marina view",
                "attributes": [
                    96,
                    38
                ]
            },
            "356": {
                "label": "City view",
                "attributes": [
                    96,
                    38
                ]
            },
            "361": {
                "label": "Harbor view",
                "attributes": [
                    96,
                    38
                ]
            },
            "358": {
                "label": "Dune view",
                "attributes": [
                    96,
                    38
                ]
            },
            "354": {
                "label": "Bay view",
                "attributes": [
                    96,
                    38
                ]
            },
            "359": {
                "label": "Garden view",
                "attributes": [
                    96,
                    38
                ]
            },
            "355": {
                "label": "Castle view",
                "attributes": [
                    96,
                    38
                ]
            },
            "357": {
                "label": "Courtyard view",
                "attributes": [
                    96
                ]
            },
            "360": {
                "label": "Golf course view",
                "attributes": [
                    96,
                    38
                ]
            },
            "514": {
                "label": "Use of commercially available disinfectants",
                "attributes": []
            },
            "488": {
                "label": "Mandatory mask-wearing",
                "attributes": []
            },
            "487": {
                "label": "Social distancing regulations",
                "attributes": []
            },
            "486": {
                "label": "Protective hygiene screens",
                "attributes": []
            },
            "489": {
                "label": "Enhanced cleaning programme",
                "attributes": []
            },
            "485": {
                "label": "Health questionnaire",
                "attributes": []
            },
            "526": {
                "label": "Time interval between room bookings",
                "attributes": []
            },
            "530": {
                "label": "Accommodation only for those vaccinated against COVID-19",
                "attributes": []
            },
            "529": {
                "label": "Wellness facilities with private area",
                "attributes": []
            },
            "518": {
                "label": "Additional hygiene measures in catering",
                "attributes": []
            },
            "517": {
                "label": "Additional safety measures in catering",
                "attributes": []
            },
            "516": {
                "label": "Protective equipment for employees",
                "attributes": []
            },
            "515": {
                "label": "Hand hygiene training for employees",
                "attributes": []
            },
            "509": {
                "label": "Health checks on staff",
                "attributes": []
            },
            "507": {
                "label": "Sanitiser dispenser",
                "attributes": []
            },
            "508": {
                "label": "Hygiene training for staff",
                "attributes": []
            },
            "490": {
                "label": "Contactless payment",
                "attributes": [
                    9,
                    41,
                    24,
                    4,
                    12,
                    5,
                    42,
                    32,
                    40,
                    31
                ]
            },
            "524": {
                "label": "Digital room access",
                "attributes": []
            },
            "491": {
                "label": "Contactless check-in/-out",
                "attributes": [
                    28,
                    29
                ]
            },
            "528": {
                "label": "Protective equipment for guests",
                "attributes": []
            },
            "525": {
                "label": "Disinfection of plastic key card",
                "attributes": []
            },
            "522": {
                "label": "No high-touch furnishings in public areas",
                "attributes": []
            },
            "492": {
                "label": "Protective masks for guests",
                "attributes": [
                    20,
                    21,
                    28
                ]
            },
            "494": {
                "label": "Medical teleconsultation",
                "attributes": [
                    20,
                    21,
                    28,
                    11,
                    17,
                    66
                ]
            },
            "493": {
                "label": "Hand sanitiser",
                "attributes": [
                    20,
                    21,
                    28
                ]
            },
            "520": {
                "label": "Disposable cutlery",
                "attributes": []
            },
            "519": {
                "label": "Packaged meals",
                "attributes": []
            },
            "521": {
                "label": "Disposable menus",
                "attributes": []
            },
            "497": {
                "label": "No buffet service",
                "attributes": []
            },
            "495": {
                "label": "Digital menu (mobile phone)",
                "attributes": []
            },
            "496": {
                "label": "Restricted buffet service",
                "attributes": []
            },
            "513": {
                "label": "Intensified room cleaning",
                "attributes": []
            },
            "527": {
                "label": "Hygiene set",
                "attributes": []
            },
            "523": {
                "label": "No high-touch furnishings",
                "attributes": []
            },
            "499": {
                "label": "Room service free of charge",
                "attributes": [
                    74,
                    75,
                    28
                ]
            },
            "498": {
                "label": "Contactless room service",
                "attributes": [
                    74,
                    75,
                    20,
                    21,
                    28
                ]
            },
            "500": {
                "label": "Housekeeping only upon request",
                "attributes": []
            },
            "510": {
                "label": "staysafe® hygiene label (powered by cooperation partner of TÜV SÜD)",
                "attributes": []
            },
            "512": {
                "label": "SAFE TOURISM (Lloyd’s Register)",
                "attributes": []
            },
            "506": {
                "label": "CLEAN 2.0 (FTI)",
                "attributes": []
            },
            "503": {
                "label": "Safe Stay (AHLA)",
                "attributes": []
            },
            "502": {
                "label": "CleanStay (Hilton)",
                "attributes": []
            },
            "504": {
                "label": "10-point plan (TUI)",
                "attributes": []
            },
            "505": {
                "label": "Hygiene plan (Enchilada)",
                "attributes": []
            },
            "501": {
                "label": "ALLSAFE (Accor/Bureau Veritas)",
                "attributes": []
            },
            "534": {
                "label": "Safe Tourism Certified (ICTE)",
                "attributes": []
            }
        },
        "attributes": {
            "201": {
                "label": "Classification agency",
                "valueType": "STRING"
            },
            "202": {
                "label": "Rating",
                "valueType": "STRING"
            },
            "203": {
                "label": "“Superior” addition"
            },
            "97": {
                "label": "Nudist"
            },
            "96": {
                "label": "Depending on the scope of service booked"
            },
            "94": {
                "label": "Flip-flops recommended"
            },
            "93": {
                "label": "Hotel-owned/private"
            },
            "92": {
                "label": "Public"
            },
            "27": {
                "label": "Non-smoking"
            },
            "57": {
                "label": "Smoking"
            },
            "91": {
                "label": "Number of holes",
                "valueType": "INTEGER"
            },
            "90": {
                "label": "Sports equipment hire"
            },
            "89": {
                "label": "Subject to availability"
            },
            "74": {
                "label": "Around the clock"
            },
            "75": {
                "label": "By the hour"
            },
            "199": {
                "label": "Time",
                "valueType": "STRING"
            },
            "200": {
                "label": "Service times",
                "valueType": "STRING"
            },
            "77": {
                "label": "Subject to weather conditions"
            },
            "64": {
                "label": "Value",
                "valueType": "STRING"
            },
            "69": {
                "label": "On-site"
            },
            "14": {
                "label": "Direct"
            },
            "26": {
                "label": "Nearby"
            },
            "35": {
                "label": "Separated by a promenade"
            },
            "36": {
                "label": "Separated by a street"
            },
            "70": {
                "label": "Locally"
            },
            "15": {
                "label": "Distance",
                "valueType": "STRING"
            },
            "71": {
                "label": "Journey time (on foot)",
                "valueType": "STRING"
            },
            "72": {
                "label": "Journey time (by car or bus)",
                "valueType": "STRING"
            },
            "73": {
                "label": "Journey time (by public transport)",
                "valueType": "STRING"
            },
            "81": {
                "label": "Deposit required"
            },
            "20": {
                "label": "For a fee"
            },
            "21": {
                "label": "Free of charge"
            },
            "28": {
                "label": "On request"
            },
            "39": {
                "label": "Third-party operator"
            },
            "78": {
                "label": "Subsidy from health insurance provider"
            },
            "22": {
                "label": "Gently sloping"
            },
            "95": {
                "label": "Steep sloping"
            },
            "33": {
                "label": "Sandy"
            },
            "55": {
                "label": "Stony"
            },
            "54": {
                "label": "Pebbly"
            },
            "79": {
                "label": "Sand surface"
            },
            "80": {
                "label": "Lawn surface"
            },
            "63": {
                "label": "Address lines",
                "valueType": "STRING"
            },
            "65": {
                "label": "Post box",
                "valueType": "STRING"
            },
            "58": {
                "label": "Street",
                "valueType": "STRING"
            },
            "59": {
                "label": "House number",
                "valueType": "STRING"
            },
            "61": {
                "label": "Postcode",
                "valueType": "STRING"
            },
            "60": {
                "label": "Place name",
                "valueType": "STRING"
            },
            "62": {
                "label": "Country",
                "valueType": "STRING"
            },
            "56": {
                "label": "Rating",
                "valueType": "RATING"
            },
            "50": {
                "label": "Year",
                "valueType": "INTEGER"
            },
            "67": {
                "label": "Warm"
            },
            "37": {
                "label": "Separate"
            },
            "43": {
                "label": "Satellite/cable"
            },
            "34": {
                "label": "Satellite TV"
            },
            "30": {
                "label": "Pay-per-view"
            },
            "8": {
                "label": "Cable"
            },
            "19": {
                "label": "Flat-screen"
            },
            "13": {
                "label": "Direct-dial"
            },
            "84": {
                "label": "Only local channels"
            },
            "85": {
                "label": "German channels"
            },
            "44": {
                "label": "Size",
                "valueType": "INTEGER"
            },
            "38": {
                "label": "Side"
            },
            "16": {
                "label": "Early-riser"
            },
            "23": {
                "label": "Late-riser"
            },
            "48": {
                "label": "Central"
            },
            "7": {
                "label": "Buffet"
            },
            "2": {
                "label": "À la carte"
            },
            "25": {
                "label": "Menu"
            },
            "10": {
                "label": "Continental"
            },
            "18": {
                "label": "English"
            },
            "82": {
                "label": "American breakfast"
            },
            "6": {
                "label": "Attended"
            },
            "88": {
                "label": "Video-camera surveillance"
            },
            "1": {
                "label": "Only included in All-Inclusive"
            },
            "68": {
                "label": "Age",
                "valueType": "INTEGER"
            },
            "45": {
                "label": "Air conditioning"
            },
            "83": {
                "label": "Underfloor heating"
            },
            "3": {
                "label": "Allowed"
            },
            "11": {
                "label": "German"
            },
            "17": {
                "label": "English"
            },
            "66": {
                "label": "French"
            },
            "51": {
                "label": "Freshwater"
            },
            "52": {
                "label": "Saltwater"
            },
            "53": {
                "label": "Heated"
            },
            "47": {
                "label": "Individual"
            },
            "46": {
                "label": "Highchair"
            },
            "9": {
                "label": "Debit cards"
            },
            "41": {
                "label": "Visa"
            },
            "24": {
                "label": "MasterCard"
            },
            "4": {
                "label": "American Express"
            },
            "12": {
                "label": "Diners"
            },
            "5": {
                "label": "AMEXCO"
            },
            "42": {
                "label": "JCB"
            },
            "32": {
                "label": "ROBINSON Card"
            },
            "40": {
                "label": "TUI Card"
            },
            "31": {
                "label": "Major credit cards"
            },
            "49": {
                "label": "Number",
                "valueType": "INTEGER"
            },
            "76": {
                "label": "Capacity max.",
                "valueType": "STRING"
            },
            "29": {
                "label": "Opening hours",
                "valueType": "STRING"
            },
            "86": {
                "label": "King-size"
            },
            "87": {
                "label": "Queen-size"
            },
            "99": {
                "label": "Single Room"
            },
            "100": {
                "label": "Double Room"
            },
            "101": {
                "label": "Twin Room"
            },
            "102": {
                "label": "Triple Room"
            },
            "103": {
                "label": "Quad Room"
            },
            "104": {
                "label": "Family Room"
            },
            "105": {
                "label": "Suite"
            },
            "106": {
                "label": "Apartment"
            },
            "107": {
                "label": "Dormitory"
            },
            "108": {
                "label": "Budget"
            },
            "109": {
                "label": "Business"
            },
            "110": {
                "label": "Classic"
            },
            "111": {
                "label": "Comfort"
            },
            "112": {
                "label": "Deluxe"
            },
            "113": {
                "label": "Economy"
            },
            "114": {
                "label": "Executive"
            },
            "115": {
                "label": "Grand"
            },
            "116": {
                "label": "Leisure"
            },
            "117": {
                "label": "Premier"
            },
            "118": {
                "label": "Prestige"
            },
            "119": {
                "label": "Standard"
            },
            "120": {
                "label": "Superior"
            },
            "121": {
                "label": "Airport View"
            },
            "122": {
                "label": "Avenue View"
            },
            "123": {
                "label": "Bay View"
            },
            "124": {
                "label": "Beach View"
            },
            "125": {
                "label": "Beachfront View"
            },
            "126": {
                "label": "Bridge View"
            },
            "127": {
                "label": "Broadway View"
            },
            "128": {
                "label": "Canal View"
            },
            "129": {
                "label": "Castle View"
            },
            "130": {
                "label": "Cathedral View"
            },
            "131": {
                "label": "City View"
            },
            "132": {
                "label": "Cliff View"
            },
            "133": {
                "label": "Coast(Line) View"
            },
            "134": {
                "label": "Courtyard View"
            },
            "135": {
                "label": "Creek View"
            },
            "136": {
                "label": "Desert View"
            },
            "137": {
                "label": "Downtown View"
            },
            "138": {
                "label": "Fairway View"
            },
            "139": {
                "label": "Falls View"
            },
            "140": {
                "label": "Fjord View"
            },
            "141": {
                "label": "Forest View"
            },
            "142": {
                "label": "Fountain View"
            },
            "143": {
                "label": "Garden View"
            },
            "144": {
                "label": "Golf View"
            },
            "145": {
                "label": "Gulf View"
            },
            "146": {
                "label": "Harbour View"
            },
            "147": {
                "label": "Hill View"
            },
            "148": {
                "label": "Hillside View"
            },
            "149": {
                "label": "Inland View"
            },
            "150": {
                "label": "Interior View"
            },
            "151": {
                "label": "Island View"
            },
            "152": {
                "label": "Jungle View"
            },
            "153": {
                "label": "Lagoon View"
            },
            "154": {
                "label": "Lake View"
            },
            "155": {
                "label": "Land View"
            },
            "156": {
                "label": "Limited View"
            },
            "157": {
                "label": "Marina View"
            },
            "158": {
                "label": "Mosque View"
            },
            "159": {
                "label": "Mountain View"
            },
            "160": {
                "label": "Nature View"
            },
            "161": {
                "label": "Ocean View"
            },
            "162": {
                "label": "Palm View"
            },
            "163": {
                "label": "Panoramic View"
            },
            "164": {
                "label": "Park View"
            },
            "165": {
                "label": "Peak View"
            },
            "166": {
                "label": "Plaza View"
            },
            "167": {
                "label": "Pool View"
            },
            "168": {
                "label": "Resort View"
            },
            "169": {
                "label": "Rice Field View"
            },
            "170": {
                "label": "River View"
            },
            "171": {
                "label": "Sea View"
            },
            "172": {
                "label": "Seafront View"
            },
            "173": {
                "label": "Side View"
            },
            "174": {
                "label": "Skyline View"
            },
            "175": {
                "label": "Spa View"
            },
            "176": {
                "label": "Square View"
            },
            "177": {
                "label": "Stadium View"
            },
            "178": {
                "label": "Street View"
            },
            "179": {
                "label": "Strip View"
            },
            "180": {
                "label": "Terrace View"
            },
            "181": {
                "label": "Theatre View"
            },
            "182": {
                "label": "Tower View"
            },
            "183": {
                "label": "Town View"
            },
            "184": {
                "label": "Urban View"
            },
            "185": {
                "label": "Valley View"
            },
            "186": {
                "label": "Village View"
            },
            "187": {
                "label": "Volcano View"
            },
            "188": {
                "label": "Walk View"
            },
            "189": {
                "label": "Water View"
            },
            "190": {
                "label": "Name",
                "valueType": "STRING"
            },
            "191": {
                "label": "Extended times"
            },
            "192": {
                "label": "Not available from (date) to (date)",
                "valueType": "DATE_RANGE"
            },
            "193": {
                "label": "Limited usage time per guest"
            },
            "194": {
                "label": "Admission only with protective mask"
            },
            "195": {
                "label": "Limited number of people"
            },
            "196": {
                "label": "Guest placement"
            },
            "197": {
                "label": "Reservation necessary"
            },
            "198": {
                "label": "Takeaway option"
            }
        },
        "units": {
            "7": {
                "label": "Star"
            },
            "8": {
                "label": "Key"
            },
            "1": {
                "label": "m"
            },
            "5": {
                "label": "km"
            },
            "6": {
                "label": "min"
            },
            "2": {
                "label": "h"
            },
            "3": {
                "label": "sqm"
            },
            "4": {
                "label": "Year"
            }
        }
    }
}